export const firebaseAuthSettings = {
	// URL you want to redirect back to. The domain (www.example.com) for this
	// URL must be whitelisted in the Firebase Console.
	handleCodeInApp: true,
	url: window.location.origin
}



// WEBPACK FOOTER //
// ./src/const.js